import React from "react"
import { Col, Row, Form, Dropdown } from "react-bootstrap"
import { getIn } from "formik"
import FormLabel from "../../../shared/formLabel"
import {
  updateCategoryClaimData,
  formIsValidUpdate,
} from "../../../../Redux/WindscreenClaim/actions"
import { useDispatch } from "react-redux"

function FormDropdownArray(props) {
  const dispatch = useDispatch()

  const {
    textDesc,
    form,
    field,
    dropdownItem,
    coverageCategory,
    coverageCode,
    propertyName,
    // formIsValid,
    formName,
    clickedNext,
    extraFieldValue,
    affectedField,
    secondPropertyName,
    secondFieldName,
  } = props

  const errorsMsg = getIn(form.errors, field.name)
  // const touched = getIn(form.touched, field.name)

  const inputErrorMessage = (touched, errors, inputName) => {
    return (clickedNext && errors[inputName]) ||
      (errors[inputName] && touched[inputName]) ? (
      <span className="InputError">{errorsMsg}</span>
    ) : null
  }

  const DropdownValueChange = (description, secondPropertyValue) => {
    let actionList = []
    let denied = false

    actionList.push(
      updateCategoryClaimData(
        coverageCategory,
        coverageCode,
        field.name,
        description
      )
    )

    if (secondFieldName) {
      actionList.push(
        updateCategoryClaimData(
          coverageCategory,
          coverageCode,
          secondFieldName,
          secondPropertyValue
        )
      )
    }

    let errorsList = form.errors
    delete errorsList[field.name]

    if (extraFieldValue && affectedField) {
      if (extraFieldValue.indexOf(description) !== -1) {
        denied = true
      }

      affectedField.forEach((FieldItem, FieldKey) => {
        delete errorsList[FieldItem]
        actionList.push(
          updateCategoryClaimData(coverageCategory, coverageCode, FieldItem, "")
        )
        form.setFieldValue(FieldItem, "")
      })
    }

    if (
      Object.entries(errorsList).length === 0 && //Check form error list is empty
      //description.indexOf("Others") === -1 && //Check selected dropdown not "Others"
      !denied
    ) {
      actionList.push(formIsValidUpdate(formName, true))
    } else {
      actionList.push(formIsValidUpdate(formName, false))
    }

    actionList.forEach((action, actionKey) => {
      dispatch(action)
    })

    form.resetForm()
    form.validateForm()
  }

  return (
    <Form.Group>
      <Row>
        <FormLabel text={textDesc} />
        <Col xs={12} md={6} className="marginTop10px">
          <Dropdown className="dropdown">
            <Dropdown.Toggle className="btn btn-secondary dropdown-toggle DropdownHeader">
              {field.value}
              {/* {dropDownValue} */}
            </Dropdown.Toggle>
            <Dropdown.Menu className="dropdown-menu DropdownMenu">
              {dropdownItem.map((item, key) => (
                <Dropdown.Item
                  key={key}
                  onClick={() => {
                    DropdownValueChange(
                      item[propertyName],
                      item[secondPropertyName]
                    )
                    form.setFieldValue(
                      field.name,
                      item[propertyName],
                      true /* force validation */
                    )
                  }}
                >
                  {item[propertyName]}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
          {/* {errors && touched && <span className="InputError">{errors}</span>} */}
          {/* <span className="InputError">{errors}</span> */}
          {inputErrorMessage(form.touched, form.errors, field.name)}
        </Col>
      </Row>
    </Form.Group>
  )
}

export default FormDropdownArray
